// extracted by mini-css-extract-plugin
export default {"label":"style_label__ExGC3","email":"style_email__cnPMH","input":"style_input__8SGMz"};